
import {
    FETCH_DRIVE_FILES_SUCCESS
  } from '../actions/types';
  
  const INITIAL_STATE = {
    driveFiles: null
  };
  
  export default function driveFileReducer (state=INITIAL_STATE, action) {

    switch (action.type) {
      case FETCH_DRIVE_FILES_SUCCESS:
        return { ...state, driveFiles: action.payload.drive_files };
      default:
        return state;
    }
  };